
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/[...slug]",
      function () {
        return require("private-next-pages/use-cases/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/[...slug]"])
      });
    }
  